import { MutationTree } from 'vuex';
import { ESettingsMutations } from './settings.constants';
import { ISettingsState } from '@/settings/store/settings.types';

export const mutations: MutationTree<ISettingsState> = {
  [ESettingsMutations.SetLoading](state: ISettingsState, loading: boolean) {
    state.loading = loading;
  },
};
